var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, border: "" } },
        [
          _vm._l(_vm.column, function (item, index) {
            return _c("el-table-column", {
              key: index,
              attrs: {
                label: item.label,
                prop: item.prop,
                "min-width": item.width,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        item.prop === "status"
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                                style: {
                                  color:
                                    scope.row[item.prop] === 1
                                      ? "#0aa653"
                                      : scope.row[item.prop] === 2
                                      ? "#dc2626"
                                      : scope.row[item.prop] === 3
                                      ? "#909399"
                                      : "#d97706",
                                },
                              },
                              [
                                _c("div", {
                                  staticStyle: {
                                    width: "5px",
                                    height: "5px",
                                    "border-radius": "50%",
                                    "margin-right": "5px",
                                  },
                                  style: {
                                    background:
                                      scope.row[item.prop] === 1
                                        ? "#0aa653"
                                        : scope.row[item.prop] === 2
                                        ? "#dc2626"
                                        : scope.row[item.prop] === 3
                                        ? "#909399"
                                        : "#d97706",
                                  },
                                }),
                                scope.row[item.prop] === 1
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.$t("userManage.effective"))
                                      ),
                                    ])
                                  : _vm._e(),
                                scope.row[item.prop] === 2
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(_vm.$t("userManage.expired"))
                                      ),
                                    ])
                                  : _vm._e(),
                                scope.row[item.prop] === 3
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("collectionCenter.Disabled")
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                                scope.row[item.prop] === 4
                                  ? _c("div", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("userManage.expiringSoon")
                                        )
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            )
                          : _c("div", [
                              _vm._v(" " + _vm._s(scope.row[item.prop]) + " "),
                            ]),
                      ]
                    },
                  },
                ],
                null,
                true
              ),
            })
          }),
          _c("el-table-column", {
            attrs: {
              label: _vm.$t("GlobalSetObj.operate"),
              fixed: "right",
              width: "240",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:user-center:temporaryWorkerAccount:view",
                                expression:
                                  "'btn:user-center:temporaryWorkerAccount:view'",
                                arg: "remove",
                              },
                            ],
                            staticStyle: { color: "#0aa653" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.viewDetailData(scope.row)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("GlobalSetObj.View")) + " ")]
                        ),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "permit",
                                rawName: "v-permit:remove",
                                value:
                                  "btn:user-center:temporaryWorkerAccount:resetPassword",
                                expression:
                                  "'btn:user-center:temporaryWorkerAccount:resetPassword'",
                                arg: "remove",
                              },
                            ],
                            staticStyle: { color: "#0aa653" },
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.resetPasswordFun(scope.row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("collectionCenter.resetPassword")
                                ) +
                                " "
                            ),
                          ]
                        ),
                        scope.row.status === 2
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:user-center:temporaryWorkerAccount:reapply",
                                    expression:
                                      "'btn:user-center:temporaryWorkerAccount:reapply'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: { color: "#0aa653" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.reapplyAccount(scope.row)
                                  },
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("userManage.Reapply")))]
                            )
                          : _vm._e(),
                        scope.row.status !== 2 && scope.row.status !== 3
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:user-center:temporaryWorkerAccount:enableDisable",
                                    expression:
                                      "'btn:user-center:temporaryWorkerAccount:enableDisable'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: { color: "#dc2626" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeStatus(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.Disable"))
                                ),
                              ]
                            )
                          : _vm._e(),
                        scope.row.status === 3
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "permit",
                                    rawName: "v-permit:remove",
                                    value:
                                      "btn:user-center:temporaryWorkerAccount:enableDisable",
                                    expression:
                                      "'btn:user-center:temporaryWorkerAccount:enableDisable'",
                                    arg: "remove",
                                  },
                                ],
                                staticStyle: { color: "#0aa653" },
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.changeStatus(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t("collectionCenter.enable"))
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }